module.exports = __webpack_public_path__ + "static/media/spoutinfo.485df79d.png";